import {
  Button, FormControl, makeStyles
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import "react-grid-layout/css/styles.css";
import { useSelector } from "react-redux";
import "react-resizable/css/styles.css";
import EmployeeService from "services/EmployeeService";

import {
  MenuItem, Select
} from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import { useEffect, useState } from "react";


const useStyles = makeStyles((theme) => ({
  setting: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    padding: "0px 10px",
    marginTop: theme.spacing(4),
    width: '100%'
  },
  wrapFilter: {
    display: "flex",
    marginBottom: 15,
  },
  formControl: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    minWidth: 120,
  },
  buttonViewDetail: {
    height: 50,
    marginLeft: 8,
    marginTop: 18,
    width: 100
  }
}));

export default function SearchFilterBar({
  department = [],
  showEmployeeField = true,
  startDate,
  endDate,
  departmentId,
  empId,
  setStartDate,
  setEndDate,
  handleSearch,
  setDepartmentId,
  setEmpId,
}) {
  const [employeeList, setEmployeeList] = useState([]);
  const classes = useStyles();
  const profile = useSelector((state) => state.user.profile);

  useEffect(async () => {
    if (!profile.departmentId) return

    const getEmployeeList = async () => {
      const response = await EmployeeService.list({ departmentId: profile.departmentId, allStatus: true });

      if (response.status) {
        setEmployeeList(response.results)
      }
    }

    getEmployeeList();

  }, [profile.departmentId]);

  return (
    <div className={classes.setting}>
      <div className={classes.wrapFilter}>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ marginRight: 10 }}
        >
          <InputLabel id="departmentId-label" htmlFor="departmentId">Department</InputLabel>
          <Select
            name="departmentId"
            label="Department"
            value={departmentId}
            onChange={(e) => {
              setDepartmentId(e.target.value)
            }}
            style={{ width: 200 }}
          >
            <MenuItem value={null}>
              All
            </MenuItem>
            {department.map((config) => (
              <MenuItem
                key={config.departmentId}
                value={config.departmentId}
              >
                {config.departmentName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {showEmployeeField && (
          <>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              style={{ marginRight: 10 }}
            >
              <InputLabel id="empId-label" htmlFor="empId">Employee</InputLabel>
              <Select
                name="empId"
                label="Employee"
                value={empId}
                onChange={(e) => {
                  setEmpId(e.target.value)
                }}
                style={{ width: 200 }}
              >
                <MenuItem value={null}>
                  All
                </MenuItem>
                {employeeList.map(e => (
                  <MenuItem value={e.empId} key={e.empId}>
                    {e.employeeFistName} {e.employeeLastName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        )}
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ marginRight: 10 }}
        >
          <DatePicker
            inputVariant="outlined"
            openTo="year"
            format="DD-MM-YYYY"
            label="Start Date"
            views={["year", "month", "date"]}
            value={startDate}
            name={`startDate`}
            onChange={(date) => {
              setStartDate(date.format("YYYY-MM-DD"));
            }}
          />
        </FormControl>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ marginRight: 10 }}
        >
          <DatePicker
            inputVariant="outlined"
            openTo="year"
            format="DD-MM-YYYY"
            label="End Date"
            views={["year", "month", "date"]}
            value={endDate}
            name={`endDate`}
            onChange={(date) => {
              setEndDate(date.format("YYYY-MM-DD"));
            }}
          />
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.buttonViewDetail}
          onClick={handleSearch}
        >
          Search
        </Button>
      </div>
    </div>
  )
}
